<template>
  <nav class="gnav">
    <ul>
      <li>
        <router-link :to="{name: 'SettingsTop'}" class="fx_ctr" @click.native="toggleSpSlide(false)">
          <span class="icon fx_ctr"><font-awesome-icon icon="cog" /></span>
          <span class="txt">Settings</span>
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'GlobalMenuBtm',
  methods: {
    ...mapActions([
      "toggleSpSlide"
    ])
  }
}
</script>